<template>
    <div class="box" v-if="brands != null && brands.length > 1 && $route.query.BrandCode == null">
        <div class="box-header">
            <div class="box-toggle" data-toggle="collapse" href="#collapseExample2" role="button" aria-expanded="true" aria-controls="collapseExample2">
                برند
                <i class="now-ui-icons arrows-1_minimal-down"></i>
            </div>
        </div>
        <div class="box-content">
            <div class="collapse show" id="collapseExample2">
                <div class="filter-option">
                    <div class="checkbox" v-for="(brand,index) in brands">
                        <input :id="'checkbox' + index" v-model="selectedBrands" :value="brand.Id" type="checkbox">
                        <label :for="'checkbox' + index">
                            {{ brand.Title }}
                        </label>
                    </div>
                </div>
                <div class="btnrange">
                    <input @click="applySelectedbrands" class="btn btn-action btn-width blue-btn" type="button" value="اعمال فیلتر" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { filterEventBus } from "../../eventBus/eventBus";
    import { isArray } from "util";
    export default {
        data() {
            return {
                selectedBrands: [],
                brands: []
            }
        },
        methods: {
            applySelectedbrands() {
                this.$parent.$data.selectedBrands = this.selectedBrands;
                filterEventBus.$emit('createQueryStringParameter');
            },
        },
        created() {
            filterEventBus.$on('initializBrands', (value) => {
                this.brands = value;
                if (this.$route.query.BrandIds != null) { 
                    if (isArray(this.$route.query.BrandIds)) {
                        this.selectedBrands = this.$route.query.BrandIds; 
                    } else {
                        this.selectedBrands.push(this.$route.query.BrandIds);
                    }
                } else {
                    this.selectedBrands = [];
                }
            });
        },
        computed: {
             
        },
        beforeDestroy() {
            filterEventBus.$off('initializBrands');
        }
    }
</script>

<style scoped>

    .box .filter-option .checkbox label::before, .checkbox label::after {
        right: 0;
        left: auto;
    }

    .checkbox label::before, .checkbox label::after {
        width: 24px;
        height: 24px;
    }
        .blue-btn {
        width: 100%;
    }

    .box .filter-option .checkbox label, .radio label {
        padding-right: 35px;
        padding-left: 0;
    }

    .checkbox label, .radio label {
        font-size: 12px;
    }
</style>